// extracted by mini-css-extract-plugin
export var numpadContainer = "_jn-1";
export var phoneButton = "_jn-0";